import { assign, isNull } from 'lodash-es'

export default function idlize(action) {
  let id = null
  let args = null

  return assign(idlize_wrapper, {
    flush,
    cancel
  })

  function idlize_wrapper() {
    args = arguments
    if (isNull(id)) {
      id = requestIdleCallback(flush)
    }
  }

  function flush() {
    cancel()
    return action.apply(null, args)
  }

  function cancel() {
    cancelIdleCallback(id)
    id = null
  }
}
